import { useContext, useState, useEffect } from "react";
import { ColDef } from "ag-grid-community";
import AgGridModalLayout from "@wrappers/layouts/AgGridModalLayout";
import {
    ParseCronString,
    NameCellRenderer,
} from "@cell-renderers/AllCellRenderers";
import { mainContext } from "@ts/constants";
import {
    IMainContext,
    Rule,
    TCommonRowData,
    TOverviewGrid,
} from "@ts/common-types";

const ActiveRulesGrid: React.FC<TOverviewGrid> = ({
    componentType,
    setGridApi,
}) => {
    const { activeRulesData } =
        useContext<IMainContext>(mainContext);
    const [rowData, setRowData] = useState<Rule[] | TCommonRowData>(
        activeRulesData
    );
    const [gridHeight, setGridHeight] = useState<number>();

    useEffect(() => {
        if(activeRulesData){
            setRowData(activeRulesData);
        }
      }, [activeRulesData]);

    const [activeRulesColumnDefs] = useState<ColDef[]>([
        {
            field: "rule_id",
            headerName: "#",
            maxWidth: 100,
            enableCellChangeFlash: true,
            pinned: true,
            filter: false,
        },
        {
            field: "name",
            headerName: "Rule Name",
            filter: "agTextColumnFilter",
            sortable: true,
            minWidth: 200,
            maxWidth: 500,
        },
        {
            field: "module",
            headerName: "Module",
            filter: "agTextColumnFilter",
            sortable: true,
            maxWidth: 400,
        },
        {
            field: "type",
            headerName: "Rule Type",
            filter: "agTextColumnFilter",
            sortable: true,
            // hide: true,
            maxWidth: 400,
        },
        {
            field: "cron_string",
            headerName: "Schedule",
            cellRenderer: ParseCronString,
            filter: "agTextColumnFilter",
            sortable: true,
            maxWidth: 400,
        },
        {
            field: "",
            headerName: "View rule",
            cellRenderer: NameCellRenderer,
        },
    ]);
    return (
        <div
            className="ag-theme-alpine"
            id="active-rules-reports-grid"
            style={
                componentType === "table"
                    ? { height: "20rem" }
                    : { height: `${gridHeight}px` }
            }
        >
            <AgGridModalLayout
                rowData={rowData}
                setGridApi={setGridApi}
                columnDefs={activeRulesColumnDefs}
                pagination={true}
                isTotalRowsReq={false}
                setGridHeight={setGridHeight}
            ></AgGridModalLayout>
        </div>
    );
};

export default ActiveRulesGrid;
